import { useCallback, useState } from 'react';

const STORAGE_KEY = 'workforce-ui.pins';

const readPins = (): string[] => {
  try {
    const raw = localStorage.getItem(STORAGE_KEY);
    const parsed: unknown = raw ? JSON.parse(raw) : [];
    return Array.isArray(parsed) ? parsed.filter((id): id is string => typeof id === 'string') : [];
  } catch {
    return [];
  }
};

export const usePins = () => {
  const [pins, setPins] = useState<string[]>(readPins);

  const togglePin = useCallback((appId: string) => {
    setPins((current) => {
      const next = current.includes(appId) ? current.filter((id) => id !== appId) : [...current, appId];
      localStorage.setItem(STORAGE_KEY, JSON.stringify(next));
      return next;
    });
  }, []);

  return { pins, togglePin };
};
